import React from "react";
import styles from "../GiveawayDetails/GiveawayDetails.module.css";

import {
  GiveawayActive,
  GiveawayArchieve,
  FormattedPrizeRange,
} from "../../types";
import GiveawayPrizesArchieve from "./components/GiveawayPrizesArchieve/GiveawayPrizesArchieve";
import GiveawayPrizesActive from "./components/GiveawayPrizesActive/GiveawayPrizesActive";

interface GiveawayPrizesProps {
  giveaway: GiveawayActive | GiveawayArchieve;
  formattedPrizes: FormattedPrizeRange[];
  userID: number;
  openNFTDetails: (detail: string) => void;
  formatNumber: (num: number) => string;
  getRewardType: (type: string) => "dc" | "ticket" | "character" | "USDT";
}

export const GiveawayPrizes: React.FC<GiveawayPrizesProps> = ({
  giveaway,
  formattedPrizes,
  userID,
  openNFTDetails,
  formatNumber,
  getRewardType,
}) => {
  return (
    <div className={styles.infoContainer}>
      <div className={styles.chanceText}>
        <div className={styles.chanceTopInfo}>Призовой фонд</div>
        <div className={styles.chanceBottomInfo}>1 купон = 1 шанс выигрыша</div>
      </div>

      {giveaway.status === "active" ||
      giveaway.status === "winner_selection" ? (
        <GiveawayPrizesActive
          giveaway={giveaway}
          formattedPrizes={formattedPrizes}
          openNFTDetails={openNFTDetails}
          formatNumber={formatNumber}
        />
      ) : (
        <GiveawayPrizesArchieve
          giveaway={giveaway}
          formattedPrizes={formattedPrizes}
          userID={userID}
          openNFTDetails={openNFTDetails}
          formatNumber={formatNumber}
          getRewardType={getRewardType}
        />
      )}
    </div>
  );
};
